var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-flow-node",style:({
    color: _vm.mainColor,
    borderColor: _vm.mainColor
  })},[_c('div',{staticClass:"iconfont",style:({
      color: _vm.mainColor
    })},[_vm._v("")]),_c('div',{staticClass:"title"},[_c('span',{domProps:{"textContent":_vm._s(_vm.title)}}),_c('span',{staticClass:"des",domProps:{"textContent":_vm._s(_vm.status)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }